var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "filter-header",
        class: { "filter-header-show": _vm.isAutoShow }
      },
      [
        _vm.isAutoShow ? _c("i", { staticClass: "fa fa-filter" }) : _vm._e(),
        _vm._v("\n    Filter\n  ")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: { "filter-body-show": _vm.isAutoShow },
        attrs: { id: "filter-body" }
      },
      [
        _vm.filters.length > 0
          ? _c(
              "div",
              _vm._l(_vm.filters, function(filter, index) {
                return _c(
                  "b-form-group",
                  {
                    key: filter.field_data_key + "-" + index,
                    staticClass: "mb-2"
                  },
                  [
                    _c("label", [_vm._v(_vm._s(filter.name))]),
                    _vm._v(" "),
                    filter.type === "text" || filter.type === "number"
                      ? _c("j-input", { attrs: { "error-required": false } })
                      : filter.type === "date"
                      ? _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c("j-input", {
                              staticClass: "mr-2",
                              attrs: {
                                "error-required": false,
                                placeholder: "Start Date"
                              }
                            }),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: {
                                "error-required": false,
                                placeholder: "End Date"
                              }
                            })
                          ],
                          1
                        )
                      : _c("j-single-select", {
                          attrs: { "error-required": false }
                        })
                  ],
                  1
                )
              })
            )
          : _c(
              "div",
              [
                _c(
                  "b-form-group",
                  [
                    _c("label", [_vm._v("Filter By")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: { "error-required": false }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { staticClass: "m__t--10" },
                  [
                    _c("label", [_vm._v("Value")]),
                    _vm._v(" "),
                    _c("j-input", { attrs: { "error-required": false } })
                  ],
                  1
                )
              ],
              1
            )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "filter-button",
        class: { "filter-button-show": _vm.isAutoShow }
      },
      [
        _c("button", { staticClass: "btn-gray", attrs: { disabled: "" } }, [
          _vm._v("\n      Reset\n    ")
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "btn-blue", attrs: { disabled: "" } }, [
          _vm._v("\n      Filter\n    ")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-377b9367", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-377b9367","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/PopupFilter.vue
// module id = null
// module chunks = 